export default "__VITE_ASSET__uGGQVV$X__";